import { Component } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { SessionExpiryService } from '../../@core/services/session-expiry.service';

/**
 * Modal bloqueante exibido quando a sessão JWT expira ou o idle timeout é atingido.
 */
@Component({
  selector: 'ngx-sessao-expirada-modal',
  templateUrl: './sessaoExpiradaModal.component.html',
  styleUrls: ['./sessaoExpiradaModal.component.scss'],
})
export class ModalSessaoExpiradaComponent {

  constructor(
    protected ref: NbDialogRef<ModalSessaoExpiradaComponent>,
    private sessionExpiry: SessionExpiryService,
  ) {}

  /**
   * Confirma encerramento: limpa storage e redireciona para login (como botão Sair).
   */
  confirmar(): void {
    this.ref.close();
    this.sessionExpiry.clearSessionAndGoToLogin();
  }
}
